module.exports = __webpack_public_path__ + "img/block7-img-card1.d9a6e9bc.svg";